import React from 'react';
import CidadePage from './CidadePage';
import cidadeSP from '../data/cidades/sao-paulo.json';

const SaoPauloPage = () => <CidadePage cidade={cidadeSP} />;

export default SaoPauloPage;
